module.exports = __webpack_public_path__ + "static/img/7.a0f0748.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/eng/7.png
// module id = McZu
// module chunks = 0